<div class="wrapper flex flex-col justify-between">
  <div class="heading flex flex-row items-center justify-between mb-[40px]">
    <div class="text-type-2">
      {{ data?.id ? (data?.name || 'Edit delivery tracking field') : 'Create delivery tracking field' }}
    </div>
  </div>
  <div class="details flex-1" [formGroup]="form">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['label']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="label"
      label="Label"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['name']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="name"
      label="Name"
    />
    <app-dropdown
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['type']"
      [options]="typeOptions"
      [parentFormGroup]="form"
      [placeholder]="'Select'"
      class="w-full mb-[20px]"
      controlName="type"
      label="Type"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['uom']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="uom"
      label="UOM"
    />

    <div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
      <div class="label text-type-13 uppercase">Is Optional</div>
      <mat-slide-toggle
        formControlName="isOptional"
        (change)="onIsOptionalToggle($event)"
        [disableRipple]="false"
        class="slide-toggle-btn"
        color="primary"
      ></mat-slide-toggle>
    </div>

    <div class="validation-section mb-[40px]">
      <div class="validation-heading">Validations</div>
<div class="flex flex-row justify-between items-center mb-[40px] gap-[20px] w-full">
      <div class="label text-type-13 uppercase">Required</div>
        <mat-slide-toggle
          formControlName="required"
          (change)="onRequiredToggle($event)"
          [disableRipple]="false"
          class="slide-toggle-btn"
          color="primary"
        ></mat-slide-toggle>
      </div>
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['required_min']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="required_min"
        label="Min"
      />
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['required_max']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="required_max"
        label="Max"
      />
    </div>

    <div class="range-section mb-[40px]">
      <div class="range-heading">Range</div>
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['range_min']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="range_min"
        label="Min"
      />
      <app-number-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['range_max']"
        [parentFormGroup]="form"
        class="w-full mb-[20px]"
        controlName="range_max"
        label="Max"
      />
    </div>
  </div>
  <div class="action-section w-full flex justify-between items-center gap-[10px] mt-[40px]">
    <app-primary-button (handleClick)="submit()" [isDisabled]="!isFormDirty" class="w-full">
      Submit
    </app-primary-button>
  </div>
</div>
